import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Card, CardHeader, CardContent } from '../components/ui/Card';

export const Admin: React.FC = () => {
  const navigate = useNavigate();
  
  const dashboardCards = [
    {
      title: 'Usuarios',
      subtitle: 'Gestionar usuarios del sistema',
      icon: (
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      onClick: () => navigate('/admin/users'),
      gradient: 'from-purple-600 to-purple-700',
      description: 'Administra usuarios, roles y permisos del sistema'
    },
    {
      title: 'Establecimientos',
      subtitle: 'Gestionar tus establecimientos',
      icon: (
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      onClick: () => navigate('/management/establishments'),
      gradient: 'from-green-600 to-green-700',
      description: 'Administra y configura tus establecimientos comerciales'
    },
    {
      title: 'Configuración Visual',
      subtitle: 'Personalizar apariencia',
      icon: (
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
        </svg>
      ),
      onClick: () => console.log('Configuración Visual - Próximamente'),
      description: 'Personaliza fuentes, colores y diseño de tus menús digitales'
    },
    {
      title: 'Menús',
      subtitle: 'Gestionar menús digitales',
      icon: (
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      ),
      onClick: () => console.log('Menús - Próximamente'),
      description: 'Crea y administra los menús digitales de tus establecimientos'
    },
    {
      title: 'Pantallas',
      subtitle: 'Gestionar pantallas de visualización',
      icon: (
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      onClick: () => console.log('Pantallas - Próximamente'),
      description: 'Configura las pantallas donde se mostrarán tus menús digitales'
    }
  ];

  return (
    <DashboardLayout
      title="HioMenu"
      subtitle="Panel de Administración"
    >
      {/* Welcome Section */}
      <div className="mb-8">
        <Card>
          <CardContent>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-16 h-16 flex-shrink-0 bg-gradient-to-br from-red-600 to-red-700 rounded-2xl flex items-center justify-center shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5} preserveAspectRatio="xMidYMid meet">
                  <rect x="3" y="4" width="18" height="14" rx="2" ry="2" />
                  <line x1="7" y1="8" x2="17" y2="8" />
                  <line x1="7" y1="12" x2="17" y2="12" />
                  <line x1="7" y1="16" x2="13" y2="16" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-2xl font-bold text-gray-900 mb-1">Panel de Administración</h2>
                <p className="text-gray-600">
                  Gestiona tus establecimientos, configura tus menús digitales y personaliza la experiencia.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Dashboard Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {dashboardCards.map((card, index) => (
          <Card key={index} hover onClick={card.onClick}>
            <CardHeader
              title={card.title}
              subtitle={card.subtitle}
              icon={card.icon}
            />
            <CardContent>
              <p className="text-sm text-gray-600 leading-relaxed">{card.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </DashboardLayout>
  );
};
